import { post } from "@/services/Backend/post";
import { Task } from "@freeconvert/freeconvert-node/dist/types";

export async function createExportTask(taskIds: string[], filename?: string) {
    return await post<Task>(`${process.env.NEXT_PUBLIC_BE_URL}/tasks/export`, {
        input: taskIds,
        archive_multiple_files: taskIds.length > 1,
        filename,
    });
}
